import React, { useState } from "react";
import { Modal, Card } from "react-bootstrap";
import { snackbar } from "@mobiscroll/react5";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const ContractTextEditorPopup = ({ show, closePopup, onSave, fileType }) => {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(false);

  // Quill modules configuration
  const modules = {
    toolbar: [
      [{ 'header': [1, 2, false] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'script': 'sub' }, { 'script': 'super' }],
      [{ 'indent': '-1' }, { 'indent': '+1' }],
      [{ 'direction': 'rtl' }],
      [{ 'align': [] }],
      ['clean']
    ],
  };

  // Quill formats configuration
  const formats = [
    'header', 'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'script', 'indent', 'direction', 'align',
  ];

  // Handle content change in the Quill editor
  const handleSave = async () => {
    if (!content.trim()) {
      snackbar({ message: "Please enter some content", color: "danger", });
      return;
    }

    setLoading(true);
    try {
      // Create a blob from the HTML content
      const blob = new Blob([content], { type: "text/html" });
      const file = new File([blob], `${fileType}.html`, { type: "text/html" });

      // Call the onSave function with the created file
      const success = await onSave(file, fileType);

      if (success) {
        setContent("");
        closePopup();
        snackbar({ message: "Contract saved successfully", color: "success", });
      }
    } catch (error) {
      console.error("Error saving content:", error);
      snackbar({ message: "Error saving content", color: "danger", });
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setContent("");
    closePopup();
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        dialogClassName="docg-modal"
        size="lg"
        centered
      >
        <Modal.Header closeButton style={{ backgroundColor: "#dee2e6", color: "#6c5b7b" }}>
          <Modal.Title>Create Contract</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Card>
            <Card.Body>
              {loading && (
                <div className="d-flex justify-content-center align-items-center mb-3">
                  <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                  <span className="ml-2">Uploading Contract...</span>
                </div>
              )}

              <div className="mb-3">
                <label className="form-label">
                  <strong>Enter Contract Content:</strong>
                </label>

                <ReactQuill
                  theme="snow"
                  value={content}
                  onChange={setContent}
                  modules={modules}
                  formats={formats}
                  placeholder="Start typing here..."
                  style={{ height: '400px', marginBottom: '50px' }} // Added margin for toolbar below
                />
              </div>

              <div className="d-flex justify-content-end gap-2">
                <button
                  type="button"
                  onClick={handleClose}
                  className="docg-patient-cancel-btn mr-2"
                  disabled={loading}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={handleSave}
                  className="docg-save-btn"
                  disabled={loading}
                >
                  Save & Upload
                </button>
              </div>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ContractTextEditorPopup; 